import React, { ReactElement } from "react";
import styles from "./packageTitle.module.scss";
import classNames from "classnames";
import { Text } from "@kunduz/ui-atoms";
import { Star01 } from "@untitled-ui/icons-react";

export const PackageTitle = (props: Props): ReactElement => {
  function isStarFilled(index: number) {
    if (!props.rating) return false;
    return index - 0.5 <= parseFloat(props.rating.replace(",", "."));
  }

  return (
    <div className={classNames(styles.container, styles[`size_${props.size}`])}>
      {props.badgeText && <p className={styles.badge}>{props.badgeText}</p>}
      {props.title && <h1 className={styles.title}>{props.title}</h1>}
      <div className={styles.row} onClick={props.onReviewsClicked}>
        {props.rating !== undefined && (
          <div className={styles.ratingWrapper}>
            <div className={styles.starWrapper}>
              {Array.from(Array(5)).map((s, t) => (
                <Star01
                  key={`star_${t}`}
                  color="#FEC84B"
                  width={16}
                  height={16}
                  className={classNames({
                    [styles.filled]: isStarFilled(t + 1),
                  })}
                />
              ))}
            </div>

            {props.rating}
          </div>
        )}
        <Text variant="textxs">•</Text>
        {props.reviewLabel && (
          <div className={styles.reviewLabel}>{props.reviewLabel}</div>
        )}
      </div>
    </div>
  );
};

interface Props {
  badgeText?: string;
  title?: string;
  rating?: string;
  reviewLabel?: string;
  size: "xs" | "sm" | "md" | "responsive";
  onReviewsClicked: () => void;
}
